import React from 'react';
import { Link } from 'react-router-dom';
import { TrendingUp, ArrowRight } from 'lucide-react';
import { results } from '../../data/mockData';
import { Button } from '../ui/button';

const ResultsSection = () => {
  return (
    <section className="py-24 bg-blue-900">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-4">RESULTS</h2>
          <p className="text-blue-200 text-lg">Our track record of success</p>
        </div>

        {/* Results Grid */}
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-6">
          {results.map((result) => (
            <Link
              key={result.id}
              to={result.link}
              className="group relative bg-white/10 backdrop-blur-sm rounded-xl p-6 border border-white/20 hover:bg-white/20 transition-all duration-300"
            >
              {/* Amount */}
              <div className="mb-4">
                <div className="flex items-center gap-2 text-amber-400 mb-1">
                  <TrendingUp className="w-4 h-4" />
                </div>
                <span className="text-3xl md:text-4xl font-bold text-white">
                  {result.amount}
                </span>
              </div>

              {/* Category */}
              <h3 className="text-white/90 text-sm font-medium leading-tight group-hover:text-amber-400 transition-colors">
                {result.category}
              </h3>

              {/* Arrow on hover */}
              <div className="absolute bottom-4 right-4 opacity-0 group-hover:opacity-100 transition-opacity">
                <ArrowRight className="w-5 h-5 text-amber-400" />
              </div>
            </Link>
          ))}
        </div>

        {/* View More Button */}
        <div className="text-center mt-12">
          <Button
            asChild
            size="lg"
            className="bg-white hover:bg-gray-100 text-blue-900 font-bold px-8 py-6 text-lg rounded-md transition-all duration-300 hover:shadow-lg"
          >
            <Link to="/results">VIEW MORE RESULTS</Link>
          </Button>
        </div>
      </div>
    </section>
  );
};

export default ResultsSection;
